import * as PIXI from "pixi.js-legacy";
import { inject, injectable } from "inversify";
import ISlots from "../../framework/src/game/slot/ISlots";
import SERVICE_IDENTIFIER from "../../framework/src/constants/identifiers";
import GameSlotsCore from "../../framework/src/game/GameSlotsCore";
import { getSprite } from "../../framework/src/modules/Sprite";
import { getRandomFloat, getRandomInt } from "../../framework/src/helpers";
import { Frames } from "../Code/Frames";
import {
    EASE,
    getTween,
    getTweenAsync,
} from "../../framework/src/modules/Tween";
import { pixiSetTimeoutAsync } from "../../framework/src/engine/pixi/pixiTimeout";
import PixiAudio from "../../framework/src/engine/pixi/PixiAudio";
import BaseSymbol from "../Symbols/BaseSymbol";

@injectable()
export default class ReSpin extends PIXI.Container {

    slots: ISlots;

    reSpinIndex: number;
    containerList: Array<Array<PIXI.Container>>;

    arrowList: Array<PIXI.Sprite>;
    audio: PixiAudio;

    constructor(
        @inject(SERVICE_IDENTIFIER.GameCore) core: GameSlotsCore,
        @inject(SERVICE_IDENTIFIER.EngineAudio) audio: PixiAudio,
    ) {
        super();

        this.slots = core.slots;
        this.audio = audio;
    }

    async run(result, index) {
        if (this.visible != true) {
            this.visible = true;
        }

        if (this.alpha != 1) {
            this.alpha = 1;
        }

        let lineWin = result.lineWins[index];

        if (lineWin.type == "showSymbols") {
            await this.respinSymbols(lineWin);
        }
    }

    /**
     * takes array of symbols that gonna get sticked (arrowed), 
     * loop through them and do the arrow animation and move them to other layer
     * @param {array} lineWin - array of objects, with line wins with the list of symbols 
     */
    async respinSymbols(lineWin) {

        let resSymbols = this.slots.getResultSymbols();
        let promiseList = [];

        for (let symbolPos of lineWin.position) {
            let symbol = resSymbols[symbolPos[0] * 3 + symbolPos[1]];
            await promiseList.push(this.symbolInRespin(symbol));
        }
        await Promise.all(promiseList);
        promiseList.length = 0;
    }

    /**
     *  each symbol that needs to be sticked (arrowed), 
     *  creates container, adds the container on symbol animation layer     
     * @param {any} symbol -- each symbol in the win line, taken from the array
     */
    async symbolInRespin(symbol: BaseSymbol) {

        let symbolContainer = new PIXI.Container();
        symbolContainer.name = "ReSpin Symbol Container";
        symbolContainer.position = symbol.position;

        let randomTargetPos = [
            getRandomInt(-2, 2),
            getRandomInt(-2, 2)
        ];

        let tempFireBackground = this.backgroundFire();
        let tempSymbol = getSprite(symbol.name + ".png", 0, 0);
        tempSymbol.name = "ReSpin Symbol";
        let tempArrow = this.arrow(symbolContainer.position.y);
        let tempArrowFlame = this.arrowFlame();

        symbol.alpha = 0;

        tempArrow.addChild(tempArrowFlame);
        symbolContainer.addChild(tempFireBackground, tempSymbol, tempArrow);
        this.addChild(symbolContainer);

        await pixiSetTimeoutAsync(getRandomFloat(0.1, 0.5));
        await this.shootArrow(tempArrow, [27 + randomTargetPos[0], (- tempFireBackground.height / 4) + randomTargetPos[1]]);
        this.audio.playTrack("bonus_Lock_Fire");
        await tempFireBackground.play();

        symbol.alpha = 1;

        if (symbolContainer.x != symbol.x && symbolContainer.y != symbol.y) {
            console.error("position doesn't fit");
        }
    }

    backgroundFire(): PIXI.AnimatedSprite {
        let tempFireRing = new PIXI.AnimatedSprite(Frames["fireRing"]);
        tempFireRing.name = "ReSpin Fire Ring";
        tempFireRing.loop = false;
        tempFireRing.animationSpeed = 0.45;
        tempFireRing.anchor.set(0.5, 0.5);
        tempFireRing.scale.set(1.1, 1.1);
        tempFireRing.position.set(0, -5);
        tempFireRing.onComplete = function () {
            tempFireRing.gotoAndPlay(34);//22); // 24 need to be fixed
        };

        return tempFireRing;
    }

    arrow(yPos): PIXI.Sprite {
        let tempArrow = getSprite("arrow_00000", -1280, yPos + 720, { x: 0, y: 0 });
        tempArrow.name = "ReSpin Arrow";
        tempArrow.pivot.set(208, 90);
        return tempArrow;
    }

    arrowFlame(): PIXI.AnimatedSprite {
        let tempFire = new PIXI.AnimatedSprite(Frames["arrowFire"]);
        tempFire.name = "ReSpin Arrow Fire";
        tempFire.pivot.set(-100, 0);
        tempFire.position.set(0, 0); // tempArrow.height/2;        
        tempFire.animationSpeed = 0.33; // 0.25; // 0.14;
        tempFire.loop = true;
        tempFire.play();
        return tempFire;
    }

    async shootArrow(
        arrow: PIXI.Sprite,
        arrowTarget: Array<number>,
    ) {

        let x = "arrow" + getRandomInt(1, 2);
        this.audio.playTrack(x, 1);

        await getTweenAsync(
            arrow.position,
            { x: arrowTarget[0], y: arrowTarget[1] },
            200,
            EASE.LINEAR
        );
    }

    returnContainerPosition(container: PIXI.Container, offSet: number) {
        container.pivot.x = 0;
        container.pivot.y = 0;
        container.position.x -= offSet;
        container.position.y -= offSet;
    }

    async clearChildList() {
        await getTweenAsync(this, { alpha: 0 }, 300, EASE.LINEAR);

        if (this.children.length > 0) {

            while (this.children.length > 0) {

                let tmpChild = this.children[this.children.length - 1] as PIXI.Container;                
                tmpChild.parent.removeChild(tmpChild);
                tmpChild.destroy({children:true});

                // console.log("child name , in respin ?", child.name);
                // this.loopThroughChildren(child);
                /*
                if (child instanceof PIXI.Container) {
                    
                    /*
                    if (child instanceof PIXI.AnimatedSprite) {
                        child.stop();
                        console.log("does this stop ?", child.name);
                    }
                    * /

                    //this.removeChild(child);
                }
                */
            }
            //this.removeChildren();
        }
        this.alpha = 1;
    }

    /*
    async loopThroughChildren(cont: PIXI.Container) {
        if (cont.children.length > 0) {
            let tempCont = cont.children[cont.children.length - 1] as PIXI.Container;
            this.loopThroughChildren(tempCont);
        } else {
            if (cont instanceof PIXI.Sprite || cont instanceof PIXI.AnimatedSprite || cont instanceof PIXI.Container) {
                console.log("respin child >", cont.name);
                let parent = cont.parent
                parent.removeChild(cont);
                console.log("parent <> this", (parent == this));
                cont.destroy();
                if (parent != this) {                    
                    this.loopThroughChildren(parent);
                }

                // child = undefined;
            }
        }
    }
    */
}